import { EuiPanel, EuiSpacer, EuiText } from "@inscopix/ideas-eui";
import { Fragment, useEffect } from "react";
import { FieldParamMapping } from "../../fields/FieldParamMapping";
import { FieldTableComboBox } from "../../fields/FieldTableComboBox";
import { ToolSpec } from "types/json-schemas/type_guards";

interface StepParamMappingProps {
  toolSpec: ToolSpec;
  dataTableId: string | undefined;
  sourceTableIds: string[];
  setSourceTableIds: (tableIds: string[]) => void;
  paramMap: {
    value: {
      [paramKey: string]:
        | {
            tableId: string | undefined;
            columnId: string | undefined;
          }
        | undefined;
    };
    isDirty: boolean;
  };
  setParamMap: (
    paramMap: {
      [paramKey: string]:
        | {
            tableId: string | undefined;
            columnId: string | undefined;
          }
        | undefined;
    },
    isDirty: boolean,
  ) => void;
}

export const StepParamMapping = ({
  toolSpec,
  dataTableId,
  sourceTableIds,
  setSourceTableIds,
  paramMap,
  setParamMap,
}: StepParamMappingProps) => {
  // Mark param map as dirty when component mounts
  useEffect(() => {
    if (!paramMap.isDirty) {
      setParamMap(paramMap.value, true);
    }
  }, [paramMap, setParamMap]);

  return (
    <Fragment>
      <EuiText>
        <h4>Map analysis inputs and parameters</h4>
      </EuiText>

      <EuiSpacer size="s" />

      <EuiText size="s">
        <p>
          For each analysis input and parameter you can optionally set data
          input sources by selecting specific columns from data or analysis
          tables. This will allow you to auto-fill your analysis specific inputs
          and parameters from your source tables.
        </p>
      </EuiText>

      <EuiSpacer />

      {dataTableId === undefined && (
        <>
          <EuiPanel color={"subdued"} hasBorder={false} hasShadow={false}>
            <FieldTableComboBox
              label="Source tables"
              disabledTableIds={[]}
              includeTable={() => true}
              value={sourceTableIds}
              onChange={setSourceTableIds}
            />
          </EuiPanel>
          <EuiSpacer />
        </>
      )}

      <FieldParamMapping
        hideTableSelector={dataTableId !== undefined}
        tableIdOptions={
          dataTableId !== undefined ? [dataTableId] : sourceTableIds
        }
        toolSpec={toolSpec}
        value={paramMap.value}
        onChange={(value) => {
          setParamMap(value, true);
        }}
      />
    </Fragment>
  );
};
